import * as tslib_1 from "tslib";
export class ConfirmDeleteModalComponent {
    constructor() {
        this.finishPromise = new Promise(() => {
        });
        this.resolveFinishPromise = () => {
        };
        this.isShowDefaultText = true;
        this.confirmationText = '';
        this.submitLebel = '';
    }
    show(deletedIdentifier) {
        this.isShowDefaultText = true;
        this.deletedIdentifier = deletedIdentifier;
        setTimeout(() => {
            this.confirmDeleteModal.show();
        }, 200);
    }
    showAwait(deletedIdentifier = "") {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.isShowDefaultText = true;
            this.finishPromise = new Promise(resolve => this.resolveFinishPromise = resolve);
            this.deletedIdentifier = deletedIdentifier;
            this.confirmDeleteModal.show();
            yield this.finishPromise;
            return this.deleted;
        });
    }
    showCustomTextAwait(confirmationText, submitLebel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.isShowDefaultText = false;
            this.submitLebel = submitLebel;
            this.confirmationText = confirmationText;
            this.finishPromise = new Promise(resolve => this.resolveFinishPromise = resolve);
            this.confirmDeleteModal.show();
            yield this.finishPromise;
            return this.deleted;
        });
    }
    delete() {
        this.deleted = true;
        this.confirmDeleteModal.hide();
        this.resolveFinishPromise();
    }
    discard() {
        this.deleted = false;
        this.confirmDeleteModal.hide();
        this.resolveFinishPromise();
    }
}
